/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface PointTransactionItem {
  id: number
  user_id: number
  amount: number
  balance_after: number
  event_type: string
  description?: string | null
  created_at: string
  user?: {
    id: number
    name: string
    email: string
    username: string
    avatar?: string
  }
}

export interface PointTransactionQueryParams extends Partial<PageQueryParams> {
  limit?: number
  user_id?: number
  event_type?: string
  type?: string
  search?: string
}

export interface PointTransactionListResponse {
  code: number
  data: PointTransactionItem[]
  total: number
  page: number
  limit: number
}

export const pointTransactionService = {
  list(params: PointTransactionQueryParams) {
    return HttpRequest.get("v1/point-transactions", {
      searchParams: params as any,
    }).json<PointTransactionListResponse>()
  },
}
